import { BasePage as CngBasePage } from 'cng-web-lib'
import DashboardTable from './DashboardTable.js'
import React from 'react'
import TranslationText from 'src/views/nmot/shared/NmotTranslationText'
import useBreadcrumbNameMap from 'src/navigations/breadcrumbs/Breadcrumb_Nmot'

function DashboardTablePage(props) {
  const translatedTextsObject = TranslationText()
  const breadcrumbNameMap = useBreadcrumbNameMap()

  return (
    <CngBasePage
      moduleTitle={translatedTextsObject.dashboard}
      renderPage={(showSnackbar) => (
        <DashboardTable
          showNotification={showSnackbar}
          {...props}
        />
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export { DashboardTablePage }
